module.exports = __webpack_public_path__ + "f089c2b95551470043a0e1bea305cdc6.fbx";